export const formatMessage = (template, vars = {}) =>
  Object.entries(vars).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, String(value)),
    String(template),
  );
